import React, {Component} from 'react';
import Loading from "../loading/loading";
import Button from "@material-ui/core/Button/Button";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import moment from "moment";
import {withStyles} from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  summaryContent: {
    flexWrap: 'wrap'
  },
});

class PersonDeleteModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: null,
    };

  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render(){
    const { classes } = this.props;
    const { expanded } = this.state;
    return (
      <div>
        <Loading displayLoader={this.props.deletingPerson}/>
        {this.props.person.scoreRecords.length > 0 && (
          <div className={'row mb-3'}>
            <div className={classes.root}>
              <div className={'col-12'}>
                <Typography variant="h6" className={'mb-3'}>
                  Person submitted score records
                </Typography>
                {
                  this.props.person.scoreRecords
                    .map(scoreRecord => {
                      return (
                        <ExpansionPanel
                          key={scoreRecord.id}
                          expanded={expanded === scoreRecord.id}
                          onChange={this.handleChange(scoreRecord.id)}
                        >
                          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{content: classes.summaryContent}}>
                            <Typography className={classes.heading}>{scoreRecord.id}</Typography>
                            <Typography className={classes.secondaryHeading}>
                              {moment(scoreRecord.createdDate).format('DD/MM/YYYY HH:mm:ss')}
                            </Typography>
                          </ExpansionPanelSummary>
                          <ExpansionPanelDetails>
                            <Table >
                              <TableBody>
                                <TableRow >
                                  <TableCell  component="th" scope="row">{'Id'}</TableCell>
                                  <TableCell>{scoreRecord.id}</TableCell>
                                </TableRow>
                                <TableRow >
                                  <TableCell  component="th" scope="row">{'Email'}</TableCell>
                                  <TableCell>{this.props.person.email}</TableCell>
                                </TableRow>
                                <TableRow >
                                  <TableCell  component="th" scope="row">{'Department'}</TableCell>
                                  <TableCell>{scoreRecord.department.name}</TableCell>
                                </TableRow>
                                <TableRow >
                                  <TableCell  component="th" scope="row">{'Type'}</TableCell>
                                  <TableCell>{this.props._getScoreRecordType(scoreRecord)}</TableCell>
                                </TableRow>
                                <TableRow >
                                  <TableCell  component="th" scope="row">{'Created Date'}</TableCell>
                                  <TableCell>{moment(scoreRecord.createdDate).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </ExpansionPanelDetails>
                        </ExpansionPanel>
                      )
                    })
                }
              </div>
            </div>
          </div>
        )}
        <div className={'row'}>
          <div className={'col-12'}>
            {
              'Are you sure you want to delete the selected person' +
              (this.props.person.scoreRecords.length > 0 ? ' along with his score records':'') +
                '?'
            }
          </div>
          <div className={'col-12 mt-3'}>
            <Button
              onClick={() => this.props.deletePerson({id: this.props.person.id})}
              variant="contained"
              color="primary"
              className={'mr-3'}
            >
              {'Yes'}
            </Button>
            <Button onClick={this.props._closeDeleteModal} variant="contained" color="secondary">
              {'No'}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default  withStyles(styles)(PersonDeleteModal);



// WEBPACK FOOTER //
// ./src/components/personsList/personDeleteModal.js